module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("CHAPTER")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 1 "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "Images",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("I’ve always really wanted a")]), _vm._v(" dog of my own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve never had one before, but I’ve always wanted one. Mom always said it wasn’t the right time, but there’s never a bad time to have a puppy in your life.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("My nanna has a cute little dog named Oreo. He’s black and white and loves to have dance parties with me. I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("love")]), _vm._v(" Oreo. I got to hang out with him all the time when ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("we lived with Nanna for a little bit. But Mom got a new job, so I don’t get to live with Oreo anymore. We just moved into a new place in Ohio.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom has worked lots of jobs. She’s worked in a circus and a school. And each time, I got to help out in my own special way too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now we were going to work where doggies and kitties came when they didn’t have homes. Mom said it was called a pet rescue. She was going to help the boss, who owned lots and lots of pet places in Ohio. Mom was going to be what’s called an “assistant director.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plus, not only did we get to go somewhere new . . . it sounded like I might be able to be around a lot of really cute animals. . . . It was another great adventure.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I hadn’t always liked new adventures. At first I was scared about going to new places. But every time we went to a new place, I got to make new friends and have new fun experiences. I’ve performed in a circus with other kids called Little Explorers, and was a helper bee at a principal’s office. And now we were at my mom’s new job. It was summer, so I didn’t have to go to school. That was good. It meant we could work at lots of jobs all summer and then maybe get a new job near a really good school that would be my forever home.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But first, I would be hanging out with animals. Lots and lots of animals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we keep one, please, please, please?” I asked my mom on the way to the rescue shelter to meet her new boss.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("One “please” doesn’t get you as much ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("as three of them. Most of the time, grown-ups don’t say yes even to three pleases, but sometimes they do. So you should always try.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Please, please, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("please")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No pets,” Mom said. “Not until we get settled somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe this will be our new home,” I said. “I like Ohio.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0004-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("I did miss Nanna, though. Nanna was two hours from here. That was a long, long way, but not too long. Mom said we could still go visit on our days off, though, which were every Sunday and sometimes Monday.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe it will be,” Mom said. “But we’re just helping out right now while the owner opens a new store, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew that, but I thought I might like this job best of all the ones we had done so far. My most favorite part of the circus was the elephant named Ella. I made friends after that and they were the best part, but I still liked the elephant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dogs and cats are even better than elephants. You know why? Because you can have them in your house. They can even sleep on your bed if your parents will let you.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("I decided this was going to be the forever job. I’d do an extra-good job and then Mom would let us have a puppy dog of our very own. Because life is just so much better if you have a puppy sleeping next to you.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0006-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b61cf79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01a.vue
// module id = 63
// module chunks = 0